import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 2rem);
`

export const ButtonWrapper = styled.div`
  & > div:first-child {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
`
